"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lib_1 = require("@brandfree-front/lib");
const react_1 = __importStar(require("react"));
const crm_components_1 = require("crm-components");
const ApiUtil_1 = __importDefault(require("../../util/ApiUtil"));
const RootStore_1 = require("../../stores/RootStore");
const EmailConfirmation = () => {
    const { translateStore: { translate } } = (0, react_1.useContext)(RootStore_1.RootStoreContext);
    const { uuid } = (0, crm_components_1.useParams)();
    const [success, setSuccess] = react_1.default.useState(null);
    react_1.default.useEffect(() => {
        validateEmail(uuid)
            .then((success) => {
            setSuccess(success.data);
        })
            .catch((ex) => {
            setSuccess(false);
            console.error(ex);
        });
    }, []);
    if (success === null) {
        return react_1.default.createElement(lib_1.Spinner, null);
    }
    const noticeTitle = success ? translate('contactInfo.emailConfirmation.success.title') : translate('contactInfo.emailConfirmation.fail.title');
    const noticeText = success ? translate('contactInfo.emailConfirmation.success.text') : translate('contactInfo.emailConfirmation.fail.text');
    const NoticeContent = () => {
        if (success) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(lib_1.Text, { element: "h3" }, noticeTitle),
                react_1.default.createElement(lib_1.Separator, { color: "invisible", spacing: "xxsmall" }),
                react_1.default.createElement(lib_1.Text, null, noticeText),
                react_1.default.createElement(lib_1.Separator, { color: "invisible", spacing: "xxsmall" })));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(lib_1.Text, null, noticeTitle),
            react_1.default.createElement(lib_1.Separator, { color: "invisible", spacing: "xxsmall" }),
            react_1.default.createElement(lib_1.Text, { className: "text-bold" }, noticeText),
            react_1.default.createElement(lib_1.Separator, { color: "invisible", spacing: "xxsmall" })));
    };
    return (react_1.default.createElement(lib_1.Notice, { type: success ? 'success' : 'error' },
        react_1.default.createElement(NoticeContent, null)));
};
const validateEmail = (uuid) => {
    return ApiUtil_1.default.post(`/contact-info/validate/${uuid}`);
};
exports.default = EmailConfirmation;
